<!-- 代理关系转移 -->
<template>
    <page>
        <c-dialog ref="memberDialog" :title="title" width="600" height="400" enable-flex @resolve="setMemberHandle">
            <c-form ref="memberForm">
                <c-form title="转出代理" title-margin="10">
                    <c-form-item type="input" label="代理昵称:" name="nick_name" disabled></c-form-item>
                    <c-form-item type="input" label="代理手机号:" name="user_manage_mobilephone" disabled></c-form-item>
                </c-form>
                <c-form title="接收代理" title-margin="10">
                    <c-form-item type="hidden" name="new_user_id"></c-form-item>
                    <c-form-item type="input" @click="$refs.memberUserSelector.open()" readonly label="修改为:"
                                 name="tran_share_user_name" required
                                 word="调整后,系统将当前代理下属所有直属邀请会员转移至新代理">
                    </c-form-item>
                </c-form>
            </c-form>
        </c-dialog>
        <member-user-selector ref="memberUserSelector" @resolve="selectHandle($event)"></member-user-selector>
    </page>
</template>

<script>
	import memberUserSelector from "@/components/service/member_user_selector.vue";

    export default {
        components: {memberUserSelector},
		props: {
        },

        data() {
            return {
                platform_user_id:0,
                title:'代理成员关系转移',
                serachParams:{}
            }
        },
		
		methods: {
			open(data) {
                this.platform_user_id = data.platform_user_id;
                this.$refs.memberForm.clear();
                this.$refs.memberForm.set({
                    nick_name: data.nick_name,
                    user_manage_mobilephone: data.user_manage_mobilephone
                });
                this.$refs.memberDialog.open();
			},

            //选择代理回调方法
            selectHandle(list) {
                var tran_share_user_name = "--";
                var new_user_id = -1;
                if (list && list[0]) {
					tran_share_user_name = (list[0].nick_name || "--") + "【" + (list[0].user_manage_mobilephone || "--") + "】";
                    new_user_id = list[0].platform_user_id || -1;
                }
                this.$refs.memberForm.set({
                    tran_share_user_name: tran_share_user_name,
                    new_user_id: new_user_id,
                });
            },
            //保存调整代理等级
            setMemberHandle(stop) {
                stop();
                this.$refs.memberForm.submit({
                    url: '/member_user/childmove',
                    rule: {
						new_user_id: [{
							type: 'empty',
							word: '请选择接收代理'
						},{
							type: 'function',
							fun: value => {
								return this.platform_user_id != value;
							},
							word: '接收代理与原代理不能相同'
						}]
                    },
                    dataFormatter: data => {
                        data.member_user_id = this.platform_user_id;
                        delete data.tran_share_user_name;
                        return data;
                    },

                    success: data => {
                        this.$refs.memberDialog.close();
                        this.$message({
                            text: '转移请求发送成功，调整结果可能稍有延迟!'
                        });
                        //调用响应方法
                        this.$emit('resolve',this.platform_user_id);
                    }
                })
            }
        }
	}
</script>